import { render, staticRenderFns } from "./SalesByBusinessChart.vue?vue&type=template&id=47af2c40"
import script from "./SalesByBusinessChart.vue?vue&type=script&lang=js"
export * from "./SalesByBusinessChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports